<template>
  <v-app id="inspire">
    <v-fab-transition v-if="!loggedIn">
      <v-btn
        name="login"
        to="/login"
        fab
        small
        fixed
        outlined
        top
        right
        color="primary"
      >
        <v-icon>account_circle</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-navigation-drawer v-else v-model="drawer" app stateless expand-on-hover>
      <v-list dense>
        <v-subheader @click.stop="drawer = !drawer">
          <v-icon left>close</v-icon>
        </v-subheader>
        <v-list-item to="/" name="home">
          <v-list-item-action>
            <v-icon>dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :to="{ path: '/immo/new', params: { id: 'new' } }"
          name="new"
        >
          <v-list-item-action>
            <v-icon>add</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>New</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/map" name="mapview">
          <v-list-item-action>
            <v-icon>map</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Map</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/list" name="listview">
          <v-list-item-action>
            <v-icon>list</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/customer" name="customerview">
          <v-list-item-action>
            <v-icon>perm_contact_calendar</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Customer</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list dense>
        <v-subheader>Account</v-subheader>
        <v-list-item to="/account" name="account">
          <v-list-item-action>
            <v-icon>account_circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="confirmLogout">
          <v-list-item-action>
            <v-icon>logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list v-if="hasRole('admin')" class="subheader" dense>
        <v-subheader>Admin</v-subheader>
        <v-list-item to="/admin/accounts" name="accounts">
          <v-list-item-action>
            <v-icon>security</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Accounts</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-fab-transition>
      <v-btn
        v-show="loggedIn && !drawer"
        @click.stop="drawer = !drawer"
        fab
        small
        fixed
        top
        left
      >
        <v-icon>menu</v-icon>
      </v-btn>
    </v-fab-transition>

    <v-main>
      <v-snackbar top right :value="updateExists" :timeout="-1" color="primary">
        An new version is available!
        <v-btn outlined @click="refreshApp">
          Update
        </v-btn>
      </v-snackbar>

      <v-container class="fill-height pa-0">
        <router-view></router-view>
      </v-container>
    </v-main>

    <!-- <v-footer class="black--text pa-4" app>
      <span>Shpia</span>
      <v-spacer></v-spacer>
      <span>&copy; 2019</span>
    </v-footer>-->
    <confirm ref="confirm"></confirm>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import confirm from '@/components/helper/confirmDialog'
import { AUTH_LOGOUT } from '@/store/actions'

export default {
  components: { confirm },
  props: {
    source: String
  },
  data: () => ({
    refreshing: false,
    registration: null,
    updateExists: false,
    drawer: false
  }),

  computed: {
    ...mapGetters(['loggedIn', 'subject', 'hasRole'])
  },

  methods: {
    ...mapActions({
      logout: AUTH_LOGOUT
    }),

    async confirmLogout() {
      if (
        await this.$root.$confirm('Logout from this device?', '', {
          color: 'red'
        })
      ) {
        this.logout()
      }
    },

    updateAvailable(event) {
      this.registration = event.detail
      this.updateExists = true
    },

    // allow user control update, needs pwa.workboxOptions.skipWaiting = false in vue.config.js
    refreshApp() {
      this.updateExists = false
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) return
      // send message to SW to skip the waiting and activate the new SW
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    }
  },

  created() {
    document.addEventListener('swUpdated', this.updateAvailable, { once: true })

    // Prevent multiple refreshes
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (this.refreshing) return
        this.refreshing = true
        // Here the actual reload of the page occurs
        window.location.reload()
      })
    }
  },

  mounted() {
    this.$root.$confirm = this.$refs.confirm.open
  }
}
</script>

<style lang="scss"></style>
